import Input from 'component/atom/forms/input/input/Input';
import Modal from 'component/hoc/modal/Modal';
import { useFormik } from 'formik';
import { categoriesToast } from 'helpers/toastMessages';
import { categoriesEndpoints } from 'hooks/endpoints';
import { usePost } from 'hooks/usePost';
import { isEmpty } from 'lodash';
import React, { useEffect } from 'react';
import styles from './AddCategory.module.scss';
import * as Yup from 'yup';
import { useToast } from 'app-context/toasterContext/ToastContext';
const Form = ({ formik }) => {
  return (
    <form
      autoComplete='off'
      onSubmit={formik.handleSubmit}
      className='formCont'
    >
      <Input
        label='Name'
        placeholder='e.g Technology'
        name='CategoryName'
        value={formik.values.CategoryName}
        onChange={formik.handleChange}
        error={formik.errors.CategoryName}
        touched={formik.touched.CategoryName}
        inputContainerClassName={styles.input}
      />
    </form>
  );
};
const AddCategory = ({
  isOpen,
  onClose,
  id,
  item,
  refetch,
  setSelectedItem,
}) => {
  const { mutate: AddCategory, isPending } = usePost({
    onSuccessToast: !isEmpty(item?.categoriesId)
      ? categoriesToast.update
      : categoriesToast.add,
    toastType: !isEmpty(item?.categoriesId) ? 'update' : 'add',
  });
  const toast = useToast();
  const validationSchema = Yup.object({
    CategoryName: Yup.string().required('Category name is Required'),
  });
  const formik = useFormik({
    initialValues: {
      CategoryName: item?.categoryText || '',
    },
    validationSchema,
    onSubmit: (values, { resetForm }) => {
      AddCategory(
        {
          url: categoriesEndpoints.createCategory(),
          data: {
            categoryName: values.CategoryName,
            botId: id,
            ...(item?.categoriesId ? { categoryId: item.categoriesId } : {}),
          },
        },
        {
          onSuccess: (e) => {
            if (!e?.data?.result?.isSuccess) {
              toast.open(e?.data?.result?.userMessage, 'delete');
              return;
            }
            refetch();
            onClose();
            setSelectedItem(null);
            resetForm();
          },
        },
      );
    },
    enableReinitialize: true,
  });
  useEffect(() => {
    if (!isOpen) {
      formik.resetForm();
    }
  }, [isOpen]);
  return (
    <>
      <Modal
        title={
          !isEmpty(item?.categoriesId) ? 'Edit Department' : 'Add Department'
        }
        isOpen={isOpen}
        onClose={onClose}
        modalContent={{
          component: <Form formik={formik} />,
        }}
        onSubmit={formik.handleSubmit}
        buttonType='submit'
        onSubmitstyles={{
          onSubmit: {
            label: 'Save',
          },
        }}
        isLoading={isPending}
      />
    </>
  );
};
export default AddCategory;
